@if (parts().prefix; as prefix) {
  <span class="prefix"
    ><bdi #prefixText>{{ prefix }}</bdi></span
  >
}
<span
  class="tail"
  [style.--ellipsis-reserve.em]="ellipsisReserveEm()"
>
  @if (parts().gap; as gap) {
    <span class="gap">{{ gap }}</span>
  }
  @for (segment of parts().tail; track $index) {
    @if (segment.isMatch) {
      <mark>{{ segment.text }}</mark>
    } @else {
      <span>{{ segment.text }}</span>
    }
  }
</span>
